export default function (){
const get_language = (locale,param) => {
    return lang[locale][param];
};
const lang = {
    "ja": {
      "画面の題名":"-------------------------------------------------------------",
      "title_item_type_to_add":"追加する項目タイプ",
      "title_item_setting":"項目設定",
      "title_preview": "プレビュー",
      "title_input_form": "入力フォーム",
      "title_view_form": "表示フォーム",
      "項目タイプ":"-------------------------------------------------------------",
      "type_short_text":"短いテキスト",
      "type_long_text":"長いテキスト",
      "type_numeric":"数値",
      "type_single_select":"単一選択",
      "type_multi_select":"複数選択",
      "type_switch":"スイッチ",
      "type_date":"日付",
      "type_time":"時刻",
      "type_datetime":"日時",
      "type_picture":"写真",
      "type_password":"パスワード",
      "type_full_name": "氏名",
      "type_phone_number":"電話番号",
      "type_mail_address":"メールアドレス",
      "type_pulldown":"プルダウン",
      "type_markdown":"マークダウン",
      "type_url":"URL",
      "type_label":"ラベル",
      "type_table":"表",
      "type_file":"ファイル添付",
      "type_sign":"手書きサイン",
      "type_link":"参照リンク",
      "項目名":"-------------------------------------------------------------",
      "subject_item_name":"項目名",
      "subject_placeholder":"説明",
      "subject_description":"補足説明",
      "subject_item_key":"項目キー",
      "subject_item_condition":"条件付き表示",
      "subject_item_condition_1":"条件付き表示",
      "subject_item_condition_2":"　",
      "subject_required":"必須選択",
      "subject_max_characters":"最大文字数",
      "subject_allowed_characters":"許可する文字",
      "subject_number_of_rows":"行数",
      "subject_min_value":"最小値",
      "subject_max_value":"最大値",
      "subject_init_value":"初期値",
      "subject_unit":"単位",
      "subject_line": "並び",
      "subject_choices":"選択肢",
      "subject_on_value":"ONの時の値",
      "subject_off_value":"OFFの時の値",
      "subject_max_width":"最大幅 80 - 1920 pixel",
      "subject_max_height":"最大高さ 80 - 1920 pixel",
      "subject_min_characters":"最小文字数",
      "subject_character_type":"含める文字種",
      "subject_item_name_1": "項目名1",
      "subject_item_name_2": "項目名2",
      "subject_placeholder_1":"説明1",
      "subject_placeholder_2":"説明2",
      "subject_hyphen":"ハイフン",
      "subject_international":"国際電話識別番号",
      "subject_allow_multiple_entries":"カンマ区切りで複数入力可能とする",
      "subject_link_when_view":"表示する時リンクにする",
      "subject_markdown":"マークダウン",
      "subject_form_viewer":"表示フォームの時に",
      "subject_label":"ラベル",
      "subject_password_hash":"パスワード暗号化（SHA-256）",
      "subject_password_view":"パスワード表示ボタン",
      "subject_output_format":"出力フォーマット",
      "subject_rows":"行",
      "subject_columns":"列",
      "subject_droparea":"ドロップエリア",
      "subject_output_method":"データ取得方法",
      "subject_max_files":"最大ファイル数",
      "subject_max_size":"最大ファイルサイズ（合計：MB）",
      "subject_height":"高さ",
      "subject_prefix":"接頭辞",
      "subject_postfix":"接尾辞",
      "subject_link_word":"リンクの文字",
      "subject_link_url":"URL",
      "プレースフォルダ":"-------------------------------------------------------------",
      "placeholder_item_name":"項目名を入力してください",
      "placeholder_placeholder":"説明を入力してください",
      "placeholder_description":"補足説明を入力してください",
      "placeholder_item_key":"項目キーを入力してください（英数字、記号は'-','_'のみ）",
      "placeholder_item_condition_1":"この項目キー",
      "placeholder_item_condition_2":"この値",
      "placeholder_max_characters":"最大文字数を入力してください",
      "placeholder_number_of_rows":"行数を入力してください",
      "placeholder_min_value":"最小値を入力してください",
      "placeholder_max_value":"最大値を入力してください",
      "placeholder_init_value":"初期値を入力してください",
      "placeholder_unit":"単位を入力してください",
      "placeholder_choice":"選択肢を入力してください",
      "placeholder_on_value":"ONの時の値",
      "placeholder_off_value":"OFFの時の値",
      "placeholder_max_width":"最大幅（pixel）を入力してください",
      "placeholder_max_height":"最大高さ（pixel）を入力してください",
      "placeholder_min_characters":"最小文字数を入力してください",
      "placeholder_label":"ラベルとして設定する文字を入力してください。",
      "placeholder_drop_here":"ここにファイルをドロップしてください",
      "placeholder_height":"高さ（pixel）を入力してください",
      "placeholder_prefix":"接頭辞を入力してください",
      "placeholder_postfix":"接尾辞を入力してください",
      "placeholder_link_word":"リンクの文字を入力してください",
      "placeholder_link_url":"URLを入力してください",
      "補足説明":"-------------------------------------------------------------",
      "description_output_method":"ファイルオブジェクトを選択した場合の取得方法は、vue3-form-producer のホームページを参照ください。",
      "description_choice_columns":'区切り文字"$"で値と表示テキストを指定することができます。例）item1$項目１',
      "条件付き表示の説明":"-------------------------------------------------------------",
      "append_text_item_condition_1":"が",
      "append_text_item_condition_2":"の時に表示",
      "選択肢の項目":"-------------------------------------------------------------",
      "selected_any":"任意",
      "selected_mandatory":"必須",
      "selected_badge":"バッジ表示",
      "selected_all":"限定しない",
      "selected_alpha":"半角英大小文字",
      "selected_numbers":"半角数字",
      "selected_alphanumeric":"半角英大小文字数字",
      "selected_ascii":"アスキー文字",
      "selected_inline": "横並び",
      "selected_stacked": "縦並び",
      "selected_include":"含む",
      "selected_not_include":"含まない",
      "selected_support":"対応する",
      "selected_not_support":"対応しない",
      "selected_allow_multiple":"複数入力可",
      "selected_deny_multiple":"複数入力不可",
      "selected_lowercase": "半角英字（小文字）",
      "selected_uppercase": "半角英字（大文字）", 
      "selected_symbols": "記号",
      "selected_link":"リンクにする",
      "selected_not_link":"リンクにしない",
      "selected_markdown_use":"使用する",
      "selected_markdown_not_use":"使用しない",
      "selected_hash":"ハッシュする",
      "selected_not_hash":"ハッシュしない",
      "selected_show":"表示する",
      "selected_not_show":"表示しない",
      "selected_base64":"Base64形式",
      "selected_file_object":"ファイルオブジェクト",
      "ボタン名称":"-------------------------------------------------------------",
      "button_clear": "クリア",
      "button_download":"ダウンロード",
      "button_display_view":"画面に表示",
      "button_copy_to_clipboard":"クリップボードにコピー",
      "button_import":"インポート",
      "button_form_check":"入力フォームを確認",
      "button_back": "戻る",
      "button_reset": "リセット",
      "button_sign": "サインをする",
      "button_erase": "消去",
      "button_cancel": "キャンセル",
      "button_done": "完了",
      "調整中表示":"-------------------------------------------------------------",
      "alert_under_adjustment":"調整中",
      "アイコンの説明":"-------------------------------------------------------------",
      "copy":"複製する",
      "delete":"削除する",
      "view_item_condition": "条件付き表示を追加",
      "hide_item_condition": "条件付き表示を削除",
      "項目の初期値":"-------------------------------------------------------------",
      "family_name":"姓",
      "first_name":"名",
      "selection1":"選択肢１",
      "selection2":"選択肢２",
      "row_name_1": "行項目名１",
      "row_name_2": "行項目名２",
      "column_name_1": "列項目名１",
      "column_name_2": "列項目名２",
      "link_prefix": "詳しくは",
      "link_postfix": "をご覧ください。",
      "link_word": "こちら",
      "link_url": "https://www.shadows-works.com/",
      "マークダウンのタブ名":"-------------------------------------------------------------",
      "tab_preview":"プレビュー",
      "tab_edit":"編集",
      "警告メッセージ":"-------------------------------------------------------------",
      "blank_items_or_invalid_items":"未入力の項目、または、無効な項目があります。",
      "please_sign":"署名が必要です。",
      "ListViewer":"-------------------------------------------------------------",
       "list_empty_text":"表示するデータはありません。"
    },
    "en": {
      "画面の題名":"-------------------------------------------------------------",
      "title_item_type_to_add":"Item type to add",
      "title_item_setting":"tem setting",
      "title_preview": "Preview",
      "title_input_form": "Input form",
      "title_view_form": "View form",
      "項目タイプ":"-------------------------------------------------------------",
      "type_short_text":"Short Text",
      "type_mail_address":"E-mail",
      "type_long_text":"Long Text",
      "type_numeric":"Numeric",
      "type_single_select":"Radio Button",
      "type_multi_select":"Check Box",
      "type_switch":"Switch",
      "type_full_name": "Full Name",
      "type_phone_number":"Phone Number",
      "type_date":"Date",
      "type_time":"Time",
      "type_datetime":"Date Time",
      "type_markdown":"Markdown",
      "type_picture":"Image",
      "type_password":"Password",
      "type_pulldown":"List",
      "type_url":"URL",
      "type_label":"Label",
      "type_table":"Table",
      "type_file":"Attach Files",
      "type_sign":"Signature",
      "type_link":"Link",
      "項目名":"-------------------------------------------------------------",
      "subject_item_name":"Item Name",
      "subject_placeholder":"Placeholder",
      "subject_description":"Description",
      "subject_item_condition":"Conditional Display",
      "subject_item_condition_1":"Conditional Display",
      "subject_item_condition_2":"Conditional Display",
      "subject_item_name_1": "Item Name 1",
      "subject_item_name_2": "Item Name 2",
      "subject_placeholder_1":"Placeholder 1",
      "subject_placeholder_2":"Placeholder 2",
      "subject_on_value":"Checked Value",
      "subject_off_value":"Unchecked Value",
      "subject_item_key":"Item Key",
      "subject_required":"Required",
      "subject_max_characters":"Maximum number of characters",
      "subject_min_characters":"Minimum number of characters",
      "subject_allowed_characters":"Allowed characters",
      "subject_number_of_rows":"Number of rows",
      "subject_min_value":"Minimum value",
      "subject_max_value":"Maximum value",
      "subject_init_value":"Initial value",
      "subject_unit":"Unit",
      "subject_choices":"Choices",
      "subject_max_width":"Maximum width 80 - 1920 pixel",
      "subject_max_height":"Maximum height 80 - 1920 pixel",
      "subject_character_type":"Character types to include",
      "subject_allow_multiple_entries":"Allow multiple entries separated by commas",
      "subject_line": "Inline or Stacked",
      "subject_hyphen":"hyphen",
      "subject_international":"International Call",
      "subject_link_when_view":"Link when view",
      "subject_markdown":"Markdown",
      "subject_form_viewer":"sw-form-viewer",
      "subject_label":"Label",
      "subject_password_hash":"Password Encryption (SHA-256)",
      "subject_password_view":"Password display button",
      "subject_output_format":"Output Format",
      "subject_rows":"Rows",
      "subject_columns":"Columns",
      "subject_droparea":"Drop Area",
      "subject_output_method":"Output Method",
      "subject_max_files":"Maximum number of files",
      "subject_max_size":"Maximum file size (total:MB)",
      "subject_height":"Height",
      "subject_prefix":"Pefix",
      "subject_postfix":"Postfix",
      "subject_link_word":"Link Word",
      "subject_link_url":"URL",
      "プレースフォルダ":"-------------------------------------------------------------",
      "placeholder_item_name":"Please enter the item name",
      "placeholder_placeholder":"Please enter a placeholder",
      "placeholder_description":"Please enter a description",
      "placeholder_item_key":"Please enter the item key (Alphanumeric characters and symbols '-' and '_' only)",
      "placeholder_item_condition_1":"Item Key",
      "placeholder_item_condition_2":"This value",
      "placeholder_max_characters":"Please enter the maximum number of characters",
      "placeholder_number_of_rows":"Please enter the number of rows",
      "placeholder_min_value":"Please enter the minimum value",
      "placeholder_max_value":"Please enter the maximum value",
      "placeholder_init_value":"Please enter the initial value",
      "placeholder_unit":"Please enter the unit",
      "placeholder_choice":"Please enter your choice",
      "placeholder_on_value":"Checked Value",
      "placeholder_off_value":"Unchecked Value",
      "placeholder_max_width":"Please enter the maximum width (pixel)",
      "placeholder_max_height":"Please enter the maximum height (pixel)",
      "placeholder_min_characters":"Please enter the minimum number of characters",
      "placeholder_label":"Enter the characters you want to set as the label.",
      "placeholder_drop_here":"Please drop here",
      "placeholder_height":"Please enter the height (pixel)",
      "placeholder_prefix":"Please enter the prefix",
      "placeholder_postfix":"Please enter the suffix",
      "placeholder_link_word":"Please enter the link text",
      "placeholder_link_url":"Enter the URL",
      "補足説明":"-------------------------------------------------------------",
      "description_output_method":"Please refer to the vue3-form-producer homepage for how to obtain the form when a file object is selected.",
      "description_choice_columns":'You can specify the value and the display text with the separator "$". Ex) item1$item 1',
      "条件付き表示の説明":"-------------------------------------------------------------",
      "append_text_item_condition_1":"is",
      "append_text_item_condition_2":", then view",
      "選択肢の項目":"-------------------------------------------------------------",
      "selected_any":"Any",
      "selected_mandatory":"Required",
      "selected_badge":"Badge",
      "selected_all":"All",
      "selected_alpha":"Alpha",
      "selected_numbers":"Numeric",
      "selected_alphanumeric":"AlphaNumeric",
      "selected_ascii":"Ascii",
      "selected_inline": "Inline",
      "selected_stacked": "Stacked",
      "selected_include":"include",
      "selected_not_include":"not include",
      "selected_support":"support",
      "selected_not_support":"not support",
      "selected_allow_multiple":"Allow multiple",
      "selected_deny_multiple":"Deny multiple",
      "selected_lowercase": "Lowercase",
      "selected_uppercase": "Uppercase", 
      "selected_symbols": "Symbols",
      "selected_link":"Link",
      "selected_not_link":"Not Link",
      "selected_markdown_use":"Use",
      "selected_markdown_not_use":"Not use",
      "selected_hash":"Hash",
      "selected_not_hash":"Not hash",
      "selected_show":"Show",
      "selected_not_show":"Not show",
      "selected_base64":"Base64",
      "selected_file_object":"File Object",
      "ボタン名称":"-------------------------------------------------------------",
      "button_clear": "Clear",
      "button_download":"Download",
      "button_display_view":"View",
      "button_copy_to_clipboard":"Copy to clipboard",
      "button_import":"Import",
      "button_form_check":"Check input form",
      "button_back": "Back",
      "button_reset": "Reset",
      "button_sign": "Sign",
      "button_erase": "Erase",
      "button_cancel": "Cancel",
      "button_done": "Done",
      "調整中表示":"-------------------------------------------------------------",
      "alert_under_adjustment":"Under Adjustment",    
      "アイコンの説明":"-------------------------------------------------------------",
      "copy":"Copy",
      "delete":"Delete",
      "view_item_condition": "Add the Conditional Display",
      "hide_item_condition": "Remove the Conditional Display",
      "項目の初期値":"-------------------------------------------------------------",
      "family_name":"Family Name",
      "first_name":"First Name",
      "selection1":"selection1",
      "selection2":"selection2",
      "row_name_1": "row1",
      "row_name_2": "row2",
      "column_name_1": "column1",
      "column_name_2": "column2",
      "link_prefix": "Click",
      "link_postfix": "for more details.",
      "link_word": "here",
      "link_url": "https://www.shadows-works.com/",
      "マークダウンのタブ名":"-------------------------------------------------------------",
      "tab_preview":"preview",
      "tab_edit":"edit",
      "警告メッセージ":"-------------------------------------------------------------",
      "blank_items_or_invalid_items":"There are blank items or invalid items.",
      "please_sign":"A signature is required.",
      "ListViewer":"-------------------------------------------------------------",
      "list_empty_text":"There are no records to show"
    }
}
return {
  get_language
}

}
